import { render, staticRenderFns } from "./AuthenticationConfirmModal.vue?vue&type=template&id=3972c161&scoped=true"
import script from "./AuthenticationConfirmModal.vue?vue&type=script&lang=js"
export * from "./AuthenticationConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./AuthenticationConfirmModal.vue?vue&type=style&index=0&id=3972c161&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3972c161",
  null
  
)

export default component.exports